import SlideApi from '@/api/slide'
import EventBus from '@/eventBus'
import util from '@/util'

const attributeKey = 'skipSlide'

const findNextIndex = (slides, skipSlides, nextIndexSlide) => {
  let newNextIndex = nextIndexSlide

  const findSlideIndex = () => {
    // Nếu hết array → trả luôn
    if (newNextIndex >= slides.length) {
      return null
    }

    // Nếu id có trong skipSlides → skip sang slide tiếp theo
    if (skipSlides[slides[newNextIndex].id]) {
      newNextIndex++
      return findSlideIndex()
    }

    // Tìm thấy slide không skip → trả index
    return newNextIndex
  }

  return findSlideIndex()
}

const findPrevIndex = (slides, skipSlides, prevIndexSlide) => {
  let newNextIndex = prevIndexSlide

  const findSlideIndex = () => {
    // Nếu vượt quá đầu array → trả null
    if (newNextIndex < 0) {
      return null
    }

    // Nếu id có trong skipSlides → lùi lại slide trước
    if (skipSlides[slides[newNextIndex].id]) {
      newNextIndex--
      return findSlideIndex()
    }

    // Tìm thấy slide không skip → trả index
    return newNextIndex
  }

  return findSlideIndex()
}

const handleCorrectSlideActivePresenting = (slides, skipSlides, slideActiveId) => {
  const index = slides.findIndex((item) => item.id === slideActiveId)
  let indexNext = index
  if (index !== -1 && skipSlides[slides[index].id]) {
    indexNext = findNextIndex(slides, skipSlides, index)
    if (indexNext !== null && indexNext !== index) {
      EventBus.$emit('onKeyboard', {
        code: 'ArrowRight',
        key: 'ArrowRight',
        keyCode: 39,
        target: {
          tagName: 'BODY',
        },
      })
      return slides[indexNext].id
    }
    if (indexNext === null) {
      indexNext = findPrevIndex(slides, skipSlides, index)
      if (indexNext !== null && indexNext !== index) {
        EventBus.$emit('onKeyboard', {
          code: 'ArrowLeft',
          key: 'ArrowLeft',
          keyCode: 37,
          target: {
            tagName: 'BODY',
          },
        })
      }
    }
  }

  if (indexNext !== null) {
    return slides[indexNext].id
  }
  return slideActiveId
}

const actions = {
  skipSlideByIdAction: async ({ commit }, payload) => {
    commit('setSkipSlideById', payload)
    await SlideApi.upsertSlideAttribute(payload.id, {
      attributeKey,
      attributeValue: payload.value,
    })
    if (payload.value) {
      util.showToastSuccess('Slide is skipped while presenting')
    } else {
      util.showToastSuccess('Slide is unskipped and will be shown while presenting')
    }
  },
  clearSkipSlidesAction: async ({ commit }) => {
    commit('clearSkipSlides')
  },

  getNextIndexSlideWithSkipSlide: ({ rootState, state }, nextIndexSlide) => {
    return findNextIndex(rootState.presentation.slides, state.skipSlides, nextIndexSlide) || nextIndexSlide
  },
  getBackIndexSlideWithSkipSlide: ({ rootState, state }, prevIndexSlide) => {
    const newPrevIndex = findPrevIndex(rootState.presentation.slides, state.skipSlides, prevIndexSlide)
    if (newPrevIndex === null) return prevIndexSlide
    return newPrevIndex
  },

  getSkipSlidesActions: async ({
    state, getters, commit, rootState, rootGetters,
  }, presentationId) => {
    if (!getters.canUseSkipSlide) return
    const resp = await SlideApi.getSlideAttributesByPresentationId({ presentationId, attributeKeys: attributeKey })
    const objSkipSlide = {}
    resp.forEach((item) => {
      objSkipSlide[item.slideId] = item.attributes
    })
    commit('setSkipSlides', objSkipSlide)
    if (rootState.sharePresentation || rootGetters.isPresenting) {
      handleCorrectSlideActivePresenting(rootState.presentation.slides, state.skipSlides, rootState.slideActive.id)
    }
  },
  presentingWithSkipSlide: async ({ getters, rootState, state }, slideActiveId) => {
    if (!getters.canUseSkipSlide) return
    handleCorrectSlideActivePresenting(rootState.presentation.slides, state.skipSlides, slideActiveId)
  },
}

export default actions
